<!-- @format -->

<template>
  <header id="header" class="container-fluid">
    <div class="row align-items-center h-100">
      <div class="col-auto logo">
        <a href="/" alt=""
          ><img
            src="@/assets/images/common/logo.svg"
            alt="웹수발주 시스템"
            height="25"
        /></a>
        <small class="ver_info ml-2">{{ this.$appInfo.version}}</small>
      </div>
      <div class="col-auto breadcrumbs px-3">
        <h3 class="mb-0">
          <span v-show="pageConfig.pagePath">{{ pageConfig.pagePath }}</span>
          <strong>{{ pageConfig.pageName }}</strong>
        </h3>
      </div>
      <!-- <div class="col-auto">
        {{ sysConfig.compInfo.businessRegNum }}
      </div> -->
      <div class="col">
        <div class="row align-items-center justify-content-end">
          <div class="col-auto">
            <div class="profile_wrap d-flex align-items-center">
              <figure class="rounded-circle">
                <img :src="companyLogoUrl" alt="" />
              </figure>
              <div class="user_info">
                <a
                  class="text-truncate"
                  href="https://www.shipwork.net/member/mypage/updateFormMypage.do"
                  :title="sysConfig.userInfo.userNm"
                >
                  <strong>{{ sysConfig.userInfo.userNm }}</strong
                  ><span>({{ sysConfig.userInfo.emplyrId }})</span>
                </a>
                <span>{{ sysConfig.compInfo.compNm }}</span>
              </div>
            </div>
            <!-- <div class="form-row align-items-center">
            </div> -->
          </div>
          <div class="col-auto options">
            <div class="option d-flex align-items-center">
              <small class="text-secondary">LANG</small>
              <DxSelectBox
                class="border-0"
                :data-source="locales"
                :value="locale"
                :input-attr="selectBoxInputAttr"
                value-expr="Value"
                display-expr="Name"
                @valueChanged="changeLocale($event)"
              />
            </div>
          </div>
          <div class="col-auto system_tools">
            <a @click="openApiExplorer" v-if="sysConfig.devMode">
              <img src="@/assets/images/common/bookmark.png" alt="" />
            </a>
            <!-- <a href="" class="bookmark"><img src="@/assets/images/common/bookmark.png" alt="" /></a>
              <a href="" class="alarm"><img src="@/assets/images/common/alarm.png" alt="" /><i>99</i></a> -->

            <a href="" class="sign" alt="log out" @click="logout()"
              ><img src="@/assets/images/common/logout.png" alt=""
            /></a>

            <!-- <a href="" class="fa fa-sign-out" alt="log out" @click="logout()"> </a> -->
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import auth from "../auth";
import { SysConfig, PageConfig } from "@/env/SysConfig.js";
import http from "@/service/util/http.js";
import DataSource from "devextreme/data/data_source";
import ApiExplorer from "@/views/Common/Modal/ApiExplorer.vue";
import { locale } from "devextreme/localization";
//import UserPanel from "./user-panel";

export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function,
  },
  created() {
    auth.getUser().then((e) => (this.user = e.data));
    this.locale = this.UserLib.fnGetLocale();
    this.locales = this.UserLib.fnInitGlobalize();

    //locale(this.locale);
  },
  data() {
    return {
      // locale: "ko",
      locales: null,
      sysConfig: SysConfig,
      pageConfig: PageConfig,
      selectBoxInputAttr: {
        id: "locale",
      },
      tempUsers: new DataSource({
        store: [
          {
            emplyrId: "shipwork01f",
            userNm: "쉽워크01 외국",
            div: "쉽워크01",
          },
          {
            emplyrId: "shipwork01d",
            userNm: "쉽워크01 내국",
            div: "쉽워크01",
          },
          {
            emplyrId: "shipwork01",
            userNm: "쉽워크01 관리자",
            div: "쉽워크01",
          },
          {
            emplyrId: "shipwork02f",
            userNm: "쉽워크02 외국",
            div: "쉽워크02",
          },
          {
            emplyrId: "shipwork02",
            userNm: "쉽워크02 관리자",
            div: "쉽워크02",
          },
          {
            emplyrId: "shipwork03f",
            userNm: "쉽워크03 외국",
            div: "쉽워크03",
          },
          {
            emplyrId: "shipwork03",
            userNm: "쉽워크03 관리자",
            div: "쉽워크03",
          },
          {
            emplyrId: "shipwork04f",
            userNm: "쉽워크04 외국",
            div: "쉽워크04",
          },
          {
            emplyrId: "shipwork04",
            userNm: "쉽워크04 관리자",
            div: "쉽워크04",
          },
        ],
        key: "emplyrId",
        group: "div",
      }),
      user: {},
      userMenuItems: [
        {
          text: "Profile",
          icon: "user",
        },
        {
          text: "Logout",
          icon: "runner",
          onClick: this.onLogoutClick,
        },
      ],
    };
  },
  methods: {
    onLogoutClick() {
      auth.logOut();
      this.$router.push({
        path: "/login-form",
        query: {
          redirect: this.$route.path,
        },
      });
    },
    changeLocale(e) {
      this.UserLib.fnChangeLocale(e.value);
      //this.$router.go();
      //document.location.reload();
    },
    openApiExplorer: function() {
      this.$modal.show(
        ApiExplorer,
        { sender: "" },
        { width: "90%", height: "100%", class: "fx_right1" },
        {
          "before-close": function() {},
        }
      );
    },
    logout() {
      localStorage.setItem("jwt", "");
      //this.$router.push({ name: "login" });
      this.$router.push({
        name: "login",
        path: "/login",
        // query: {
        //   redirect: this.$route.path,
        // },
      });
    },
  },
  components: {
    // DxButton,
    // DxToolbar,
    // DxItem,
    // DxSelectBox,
    //UserPanel,
  },
  computed: {
    currentUserId: function() {
      return {
        emplyrId: localStorage.getItem("userId"),
        userNm: localStorage.getItem("userNm"),
      };
    },
    companyLogoUrl: function() {
      if (this.sysConfig?.userInfo?.compId) {
        return `https://www.shipwork.net/company/mgnt/info/${this.sysConfig.userInfo.compId}/image/COMPANY_LOGO`;
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 40px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 3px;
  }
}
</style>
